import React, { useState } from 'react'
import { Card, Collapse } from 'react-bootstrap'
import './EqxCard.css'

interface EqxCardProps {
    header?: string | React.ReactNode
    title?: string | React.ReactNode
    subtitle?: string | React.ReactNode
    headerRight?: string | React.ReactNode
    collapsible?: boolean
    initialShow?: boolean
    show?: boolean
    setShow?: Function
    children?: React.ReactNode
    isChild?: boolean
    footer?: string | React.ReactNode
    noPadding?: boolean
    isSection?: boolean
    className?: string
    body?: () => React.ReactNode
    disabled?: boolean
    disabledMessage?: string | React.ReactNode
}
const EqxCard = (props: EqxCardProps) => {
    const [_show, _setShow] = useState(props.initialShow ?? true)
    const collapsible = props.collapsible ?? true
    const show = !collapsible || (props.show ?? _show)
    const handleShow = () => {
        if (!collapsible) return
        _setShow(!show)
        if (props.setShow) props.setShow(!show)
        return false
    }
    //styles
    const iconClosedStyle = {
        marginRight: '0.3rem',
        transition: 'all 0.2s ease',
    }
    const iconOpenStyle = { ...iconClosedStyle, transform: 'rotate(180deg)' }
    return (
        <Card
            className={
                (props.isChild ? 'eqx-card-child ' : '') +
                (props.isSection ? 'eqx-card-section ' : '') +
                (show ? 'eqx-card-open ' : 'eqx-card-closed ') +
                (collapsible ? 'eqx-card-collapsible ' : '') +
                (props.className ? props.className + " " : '') +
                'eqx-card'
            }
        >
            {(props.header || props.headerRight || props.title) && (
                <Card.Header>
                    {props.headerRight && <div className="eqx-card-right">{props.headerRight}</div>}
                    {props.title && (
                        <h5 className="card-header-title">
                            {collapsible ? (
                                <a className="clickable" onClick={handleShow}>
                                    <span
                                        className="collapsible-card-icon fas fa-chevron-down"
                                        style={show ? iconOpenStyle : iconClosedStyle}
                                    ></span>{' '}
                                    {props.title}
                                </a>
                            ) : (
                                props.title
                            )}
                        </h5>
                    )}
                    {props.subtitle && <div className="eqx-card-header-subtitle">{props.subtitle}</div>}
                    {props.header}
                </Card.Header>
            )}
            {show && (
                <Collapse in={show}>
                    <Card.Body className={props.noPadding ? 'p-0' : ''}>
                        {props.body ? props.body() : props.children}
                    </Card.Body>
                </Collapse>
            )}
            {props.footer && <Card.Footer>{props.footer}</Card.Footer>}
            {props.disabled && <div className="eqx-card-disabled">{props.disabledMessage ?? 'This feature is not available while offline'}</div>}
        </Card>
    )
}
const EqxCardEmpty = (props: { children?: React.ReactNode }) => {
    return <div className="p-4 text-center text-muted">{props.children ?? 'None'}</div>
}

export { EqxCard as default, EqxCardEmpty }

